 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"algemene-voorwaarden":"algemene-voorwaarden","animatie~branding~contact~gratis-branding-sessie~illustratie~landingspage-branding":"animatie~branding~contact~gratis-branding-sessie~illustratie~landingspage-branding","animatie~branding~contact~illustratie":"animatie~branding~contact~illustratie","animatie":"animatie","branding":"branding","contact":"contact","illustratie":"illustratie","gratis-branding-sessie~landingspage-branding":"gratis-branding-sessie~landingspage-branding","gratis-branding-sessie":"gratis-branding-sessie","landingspage-branding":"landingspage-branding","cultuur":"cultuur","kiosk":"kiosk","netflix":"netflix","noIE":"noIE","privacy-verklaring":"privacy-verklaring","werk":"werk","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4":"werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49":"werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49","werk/avans-hogeschool~werk/wageningen-universiteit":"werk/avans-hogeschool~werk/wageningen-universiteit","werk/avans-hogeschool":"werk/avans-hogeschool","werk/wageningen-universiteit":"werk/wageningen-universiteit","werk/gowallet":"werk/gowallet","werk/loud-audiovisuals":"werk/loud-audiovisuals","werk/mobilyze":"werk/mobilyze","werk/team-changing-academy":"werk/team-changing-academy","werk/newschain":"werk/newschain","werk/first-energy-gum":"werk/first-energy-gum","werkwijze":"werkwijze"}[chunkId]||chunkId) + "." + {"algemene-voorwaarden":"3e49876f","animatie~branding~contact~gratis-branding-sessie~illustratie~landingspage-branding":"84363157","animatie~branding~contact~illustratie":"68ca18de","animatie":"5f651d48","branding":"21099795","contact":"5e4f4d37","illustratie":"9e725751","gratis-branding-sessie~landingspage-branding":"c0e963b6","gratis-branding-sessie":"48bddfba","landingspage-branding":"ba1eea13","cultuur":"9a5c7c0d","kiosk":"75c34321","netflix":"922799a4","noIE":"0b79fef4","privacy-verklaring":"9cf84abe","werk":"71104f78","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4":"cbf30357","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49":"55152cd5","werk/avans-hogeschool~werk/wageningen-universiteit":"7517cf31","werk/avans-hogeschool":"c949ce69","werk/wageningen-universiteit":"8af5265e","werk/gowallet":"11172187","werk/loud-audiovisuals":"16801437","werk/mobilyze":"f22bd127","werk/team-changing-academy":"a1658597","werk/newschain":"141fd980","werk/first-energy-gum":"0c0d5fab","werkwijze":"f536487e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"algemene-voorwaarden":1,"animatie~branding~contact~illustratie":1,"animatie":1,"branding":1,"contact":1,"illustratie":1,"gratis-branding-sessie~landingspage-branding":1,"gratis-branding-sessie":1,"landingspage-branding":1,"cultuur":1,"kiosk":1,"netflix":1,"noIE":1,"privacy-verklaring":1,"werk":1,"werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4":1,"werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49":1,"werk/avans-hogeschool~werk/wageningen-universiteit":1,"werk/avans-hogeschool":1,"werk/wageningen-universiteit":1,"werk/gowallet":1,"werk/loud-audiovisuals":1,"werk/mobilyze":1,"werk/team-changing-academy":1,"werk/newschain":1,"werk/first-energy-gum":1,"werkwijze":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"algemene-voorwaarden":"algemene-voorwaarden","animatie~branding~contact~gratis-branding-sessie~illustratie~landingspage-branding":"animatie~branding~contact~gratis-branding-sessie~illustratie~landingspage-branding","animatie~branding~contact~illustratie":"animatie~branding~contact~illustratie","animatie":"animatie","branding":"branding","contact":"contact","illustratie":"illustratie","gratis-branding-sessie~landingspage-branding":"gratis-branding-sessie~landingspage-branding","gratis-branding-sessie":"gratis-branding-sessie","landingspage-branding":"landingspage-branding","cultuur":"cultuur","kiosk":"kiosk","netflix":"netflix","noIE":"noIE","privacy-verklaring":"privacy-verklaring","werk":"werk","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4":"werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49":"werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49","werk/avans-hogeschool~werk/wageningen-universiteit":"werk/avans-hogeschool~werk/wageningen-universiteit","werk/avans-hogeschool":"werk/avans-hogeschool","werk/wageningen-universiteit":"werk/wageningen-universiteit","werk/gowallet":"werk/gowallet","werk/loud-audiovisuals":"werk/loud-audiovisuals","werk/mobilyze":"werk/mobilyze","werk/team-changing-academy":"werk/team-changing-academy","werk/newschain":"werk/newschain","werk/first-energy-gum":"werk/first-energy-gum","werkwijze":"werkwijze"}[chunkId]||chunkId) + "." + {"algemene-voorwaarden":"00c794fc","animatie~branding~contact~gratis-branding-sessie~illustratie~landingspage-branding":"31d6cfe0","animatie~branding~contact~illustratie":"bc91a3ce","animatie":"bf037c1c","branding":"069e2a3a","contact":"0786c824","illustratie":"968e0d14","gratis-branding-sessie~landingspage-branding":"a259636c","gratis-branding-sessie":"c34cc11d","landingspage-branding":"7500803d","cultuur":"24ec9868","kiosk":"9169c917","netflix":"cdc236d4","noIE":"9b17b274","privacy-verklaring":"00c794fc","werk":"c207ba41","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/newschain~werk/team-ch~93caf3b4":"42c33b29","werk/avans-hogeschool~werk/gowallet~werk/loud-audiovisuals~werk/mobilyze~werk/team-changing-academy~~d31faf49":"d6518af0","werk/avans-hogeschool~werk/wageningen-universiteit":"1d114299","werk/avans-hogeschool":"45124294","werk/wageningen-universiteit":"da84e7c0","werk/gowallet":"00e8110d","werk/loud-audiovisuals":"0294774d","werk/mobilyze":"d2740be4","werk/team-changing-academy":"976bdd11","werk/newschain":"438c7ef1","werk/first-energy-gum":"b791f76a","werkwijze":"2365ce74"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.foldedpaper.nl/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
